module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'datepicker datepicker-' + _vm.type
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('span', [_c('button', {
    class: 'prev' + (_vm.canGoToPrevious ? '' : ' disabled'),
    on: {
      "click": _vm.prevMonth
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-left",
      "scale": 0.7
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "month"
  }, [_c('Dropdown', {
    ref: "monthDropdown",
    attrs: {
      "options": _vm.validMonths,
      "validated": false,
      "value": '',
      "label": "",
      "with-background": false,
      "bold-label": false,
      "allow-empty": false,
      "combo": false,
      "type": "month"
    },
    on: {
      "changed": _vm.updateMonthFromPicker
    }
  })], 1), _vm._v(" "), _c('span', [_c('button', {
    class: 'next' + (_vm.canGoToNext ? '' : ' disabled'),
    on: {
      "click": _vm.nextMonth
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right",
      "scale": 0.7
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dates"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, _vm._l((_vm.days), function(day) {
    return _c('div', {
      staticClass: "th"
    }, [_vm._v("\n            " + _vm._s(day.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, _vm._l((_vm.weeks), function(week) {
    return _c('div', {
      staticClass: "tr"
    }, _vm._l((week.days), function(day, index) {
      return _c('div', {
        staticClass: "td"
      }, [(!index) ? _c('span', {
        staticClass: "week-number"
      }, [_vm._v("\n              v." + _vm._s(_vm._f("date")(week.days[0].value, 'W')) + "\n            ")]) : _vm._e(), _vm._v(" "), (day.visible) ? _c('button', {
        class: [
          'day',
          day.active && 'active',
          day.activeRange && 'active-range',
          day.activeEnd && 'active-end',
          day.current && 'current',
          day.unavailable && 'unavailable',
          day.special && 'special' ],
        attrs: {
          "disabled": !day.enabled
        },
        on: {
          "click": function($event) {
            return _vm.setValue(day)
          }
        }
      }, [_c('popper', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showPopper(day)),
          expression: "showPopper(day)"
        }],
        attrs: {
          "trigger": "hover",
          "options": {
            placement: 'right'
          }
        }
      }, [_c('div', {
        staticClass: "popper"
      }, [_c('div', [_vm._v("Fullbokat")])]), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "reference"
        },
        slot: "reference"
      }, [_vm._v("\n                " + _vm._s(day.label) + "\n              ")])]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.showPopper(day)),
          expression: "!showPopper(day)"
        }]
      }, [_vm._v("\n              " + _vm._s(day.label) + "\n            ")])], 1) : _vm._e()])
    }), 0)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29593774"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Datepicker.vue
// module id = 911
// module chunks = 0